import { render, staticRenderFns } from "./RelatedProduct.vue?vue&type=template&id=1f5234c8&scoped=true&"
import script from "./RelatedProduct.vue?vue&type=script&lang=js&"
export * from "./RelatedProduct.vue?vue&type=script&lang=js&"
import style0 from "./RelatedProduct.vue?vue&type=style&index=0&id=1f5234c8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f5234c8",
  null
  
)

export default component.exports